<template>
  <div class="zadi-sessions">
    <ag-table :data-source-api="getAllSessions" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitAddNewRecord="onCreateSession()"
      @emitExportToExcel="onExportToExcel" />

    <tm-popup :submit="onSessionPopupSubmit" :title="sessionPopupTitle" ref="sessionPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-input class="w-full" name="عنوان الجلسة" placeholder="عنوان الجلسة" type="text"
            validation-rules="required" v-model="session.title" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="التاريخ" placeholder="التاريخ" type="date" validation-rules="required"
            v-model="session.date" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="عدد المقاعد" placeholder="عدد المقاعد" type="number"
            validation-rules="required" v-model="session.totalSeats" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="من الساعة" placeholder="من الساعة" type="time" validation-rules="required"
            v-model="session.startTime" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="إلى الساعة" placeholder="إلى الساعة" type="time" validation-rules="required"
            v-model="session.endTime" />
        </div>
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" :options="supervisors" label="name" validation-rules="required"
            name="المشرفون" multiple :reduce="(supervisor) => supervisor.id" v-model="session.supervisorIds">
            <!-- <template #option="supervisor">
              <div class="flex items-center justify-between">
                <span>{{ supervisor.name }}</span>
                <vs-chip class="supervisor-option-chip" :color="zadiAccess(supervisor).color">
                  {{ zadiAccess(supervisor).label }}
                </vs-chip>
              </div>
            </template> -->
          </tm-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="positiveCoupons" label="name"
            name="كوبون الحضور" :reduce="(coupon) => coupon.code" v-model="session.attendCouponCode" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="negativeCoupons" label="name"
            name="كوبون التغيب" :reduce="(coupon) => coupon.code" v-model="session.noShowCouponCode" />
        </div>
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" :options="negativeCoupons" label="name"
            name="كوبون الحضور دون تسجيل" :reduce="(coupon) => coupon.code"
            v-model="session.unregisteredAttendCouponCode" />
        </div>
        <div class="vx-col w-full mb-2 mt-4">
          <p class="mt-2 px-2" style="font-size: smaller">الوصف</p>
          <tm-text-area class="w-full" name="الوصف" validation-rules="required" v-model="session.description" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import { RepositoryFactory as LoyaltyRepositoryFactory } from "../../../loyalty-system/loyalty-repositories/loyaltyRepositoryFactory";
import AgTable from "@/app/shared/shared-components/ag-grid/AgTableServerSide";
import AgTableBtnCell from "@/app/shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import utilities from "@/app/shared/utilities/index";
import { ZadiSession, toZadiSessionPayload, sessionSupervisorNames } from "../../models";
// import moment from "moment";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");
const supervisorsRepo = RepositoryFactory.get("supervisorsRepository");
const couponsRepo = LoyaltyRepositoryFactory.get("couponsRepository");

const ADD_POPUP_TITLE = "إضافة جلسة زادي جديدة";

export default {
  name: "ZadiSessionsManagement",
  components: {
    TmInput,
    TmTextArea,
    TmSelect,
    TmPopup,
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      apiQuery: "",
      sessionPopupTitle: ADD_POPUP_TITLE,
      status: {
        pending: "قيد الانتظار",
        published: "منشورة",
        in_progress: "قيد التنفيذ",
        completed: "مكتملة",
        cancelled: "ملغية",
      },
      permissions: {
        add: "training_courses_management",
        edit: "training_courses_management",
        delete: "training_courses_management",
      },
      supervisors: [],
      coupons: [],
      session: ZadiSession(),
    };
  },
  computed: {
    positiveCoupons() {
      return this.coupons.filter((coupon) => coupon.points >= 0);
    },
    negativeCoupons() {
      return this.coupons.filter((coupon) => coupon.points < 0);
    },
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "المعرف",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "العنوان",
          field: "title",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        // {
        //   headerName: "الوصف",
        //   field: "description",
        //   filter: "agTextColumnFilter",
        //   width: 210,
        //   sortable: false,
        // },
        {
          headerName: "التاريخ",
          field: "date",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.date ? utilities.formatDate(params.data.date, "yyyy-MM-DD") : "-";
          },
        },
        {
          headerName: "من الساعة",
          field: "startTime",
          width: 160,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.startTime ? String(params.data.startTime).substring(0, 5) : "-";
          },
        },
        {
          headerName: "إلى الساعة",
          field: "endTime",
          width: 160,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.endTime ? String(params.data.endTime).substring(0, 5) : "-";
          },
        },
        {
          headerName: "المشرفون",
          field: "supervisors",
          width: 240,
          sortable: false,
          valueGetter: function getObject(params) {
            return sessionSupervisorNames(params.data);
          },
        },
        {
          headerName: "عدد المقاعد",
          field: "totalSeats",
          // filter: "agNumberColumnFilter",
          width: 180,
          sortable: true,
        },
        // {
        //   headerName: "المسجلون",
        //   width: 160,
        //   sortable: false,
        //   valueGetter: function getObject(params) {
        //     const total = params.data.totalSeats || 0;
        //     const available = params.data.availableSeats == null ? total : params.data.availableSeats;
        //     return (total - available) + " / " + total;
        //   },
        // },
        {
          headerName: "عدد المسجلين",
          field: "registeredVolunteersCount",
          width: 180,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.registeredVolunteersCount == null
              ? "-"
              : params.data.registeredVolunteersCount;
          },
        },
        {
          headerName: "المقاعد المتبقية",
          field: "availableSeats",
          width: 180,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.availableSeats == 0 ? "اكتمل العدد" : params.data.availableSeats;
          },
        },
        {
          headerName: "الحالة",
          field: "status",
          width: 180,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.status[params.data.status] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: (params) => self.status[params.value] || params.value,
          },
        },
        {
          headerName: "التفعيل",
          field: "isEnabled",
          width: 180,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.getEnabledLabel(params.data);
          },
        },
        {
          headerName: "كوبون الحضور",
          field: "attendCouponName",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.attendCouponName || "-";
          },
        },
        {
          headerName: "كوبون التغيب",
          field: "noShowCouponName",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.noShowCouponName || "-";
          },
        },
        {
          headerName: "كوبون الحضور دون تسجيل",
          field: "unregisteredAttendCouponName",
          width: 230,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.unregisteredAttendCouponName || "-";
          },
        },
        {
          headerName: "تفعيل الجلسة",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: params.data.isEnabled ? "تعطيل" : "تفعيل",
              type: "gradient",
              permission: self.permissions.edit,
              // التفعيل والتعطيل مرفوضان من السيرفر بعد تسوية الكوبونات
              disabled: ["completed", "cancelled"].includes(params.data.status),
              click(session) {
                self.onToggleSessionEnabled(session);
              },
            };
          },
        },
        {
          headerName: "نشر الجلسة",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: params.data.status === "published" ? "إضافة متطوعين" : "نشر الجلسة",
              type: "gradient",
              permission: self.permissions.edit,
              disabled: !["pending", "published"].includes(params.data.status),
              click(session) {
                self.$router.push({
                  path: `/volunteers/zadi-sessions/${session.id}/publish`,
                });
              },
            };
          },
        },
        {
          headerName: "سجل الحضور",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "سجل الحضور",
              type: "gradient",
              permission: self.permissions.edit,
              disabled: params.data.status === "pending",
              click(session) {
                self.$router.push({
                  path: `/volunteers/zadi-sessions/${session.id}/check-ins`,
                });
              },
            };
          },
        },
        {
          headerName: "إنهاء الجلسة",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إنهاء الجلسة",
              type: "gradient",
              permission: self.permissions.edit,
              disabled:
                !["published", "in_progress"].includes(params.data.status),
                // || !self.isSessionOver(params.data),
              click(session) {
                self.onCompleteSession(session);
              },
            };
          },
        },
        {
          headerName: "الإجراءات",
          sortable: false,
          cellRendererFramework: AgTableBtnCell,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            editRecord: function (session) {
              self.onUpdateSession(session);
            },
            deleteRecord: function (session) {
              self.onRemoveSession(session);
            },
            repeatRecord: function (session) {
              self.onDuplicateSession(session);
            },
            viewUsersRecord: function (session) {
              self.$router.push({
                path: `/volunteers/zadi-sessions/${session.id}/volunteers`,
              });
            },
            // لا متطوعين مضافين قبل النشر، فالنشر هو ما يبني جمهور الجلسة
            disabledRecordActions: function (data) {
              return data.status === "pending" ? ["view-users"] : [];
            },
            // disabledRecordActions: function (data) {
              // const disabled = [];
              // if (data.status !== "pending") disabled.push("edit");
              // if (data.status !== "pending") disabled.push("delete");
              // return disabled;
            // },
            actions: ["edit", "delete", "repeat", "view-users"],
            permissions: self.permissions,
          },
        },
      ];
    },
    // الجلسة قابلة للإنهاء فقط بعد انقضاء وقت انتهائها
    // isSessionOver(session) {
    //   if (!session.date) return false;
    //   const day = String(session.date).substring(0, 10);
    //   const endTime = session.endTime || "23:59:59";
    //   return moment(`${day} ${endTime}`, "YYYY-MM-DD HH:mm:ss").isBefore(moment());
    // },
    async getAllSessions(query) {
      this.apiQuery = `${query}&filter=status||$notin||completed`;
      return await zadiSessionsRepo.fetchZadiSessions(this.apiQuery);
    },
    async onExportToExcel() {
      await zadiSessionsRepo.exportZadiSessions(this.apiQuery);
    },
    async getAllSupervisors() {
      const response = await supervisorsRepo.fetchSupervisors("?limit=1000&sort=name,ASC");
      this.supervisors = response.data || [];
    },
    async getAllCoupons() {
      const response = await couponsRepo.fetchCoupons("?filter=app.name||$cont||المتطوعين&limit=1000");
      this.coupons = response.data || [];
    },
    onCreateSession() {
      this.sessionPopupTitle = ADD_POPUP_TITLE;
      this.resetSessionForm();
      this.$refs.sessionPopup.open();
    },
    onUpdateSession(session) {
      this.sessionPopupTitle = "تعديل جلسة زادي";
      this.session = ZadiSession(session);
      this.$refs.sessionPopup.open();
    },
    resetSessionForm() {
      this.session = ZadiSession();
    },
    async onSessionPopupSubmit() {
      try {
        const payload = toZadiSessionPayload(this.session);
        if (this.session.id) {
          await zadiSessionsRepo.updateZadiSession({ ...payload, id: this.session.id });
        } else {
          await zadiSessionsRepo.createZadiSession(payload);
        }
        this.$refs.sessionPopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });
        this.resetSessionForm();
      } catch (err) {
        this.$refs.sessionPopup.endLoading();
      }
    },
    // zadiAccess(supervisor) {
    //   const permissions = supervisor.permissions || [];
    //   if (permissions.includes("check_in_zadi_sessions")) return { label: "تسجيل الحضور", color: "success" };
    //   if (permissions.includes("view_zadi_sessions")) return { label: "عرض الجلسات فقط", color: "primary" };
    //   return { label: "بدون صلاحيات زادي", color: "warning" };
    // },
    async onRemoveSession(session) {
      await zadiSessionsRepo.removeZadiSession(session.id);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onDuplicateSession(session) {
      await zadiSessionsRepo.duplicateZadiSession(session.id);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    onCompleteSession(session) {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "إنهاء الجلسة",
        text: "سيتم احتساب المتغيبين ومنحهم كوبون التغيب. لا يمكن التراجع عن هذا الإجراء.",
        acceptText: "إنهاء",
        cancelText: "إلغاء",
        accept: () => this.completeSession(session),
      });
    },
    async completeSession(session) {
      const response = await zadiSessionsRepo.completeZadiSession(session.id);
      if (response && response.data && response.data.noShowCount != null) {
        this.$vs.notify({
          title: "إنهاء الجلسة",
          color: "success",
          text: `عدد المتغيبين: ${response.data.noShowCount}`,
        });
      }
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    // isEnabled يحسبه السيرفر بتوقيت المؤسسة، و enabledOverride = null يعني أن الحالة تتبع تاريخ الجلسة
    getEnabledLabel(session) {
      if (session.isEnabled == null) return "-";
      const state = session.isEnabled ? "مفعّلة" : "معطّلة";
      return session.enabledOverride == null ? `${state} (تلقائياً)` : `${state} (يدوياً)`;
    },
    onToggleSessionEnabled(session) {
      const isEnabling = !session.isEnabled;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: isEnabling ? "تفعيل الجلسة" : "تعطيل الجلسة",
        text: isEnabling
          ? "ستظهر الجلسة في تطبيق المشرف ويُسمح بتسجيل الحضور فيها حتى قبل موعدها."
          : "ستختفي الجلسة من تطبيق المشرف ويُمنع تسجيل الحضور فيها حتى لو حلّ موعدها.",
        acceptText: isEnabling ? "تفعيل" : "تعطيل",
        cancelText: "إلغاء",
        accept: () => this.setSessionEnabled(session, isEnabling),
      });
    },
    async setSessionEnabled(session, isEnabling) {
      if (isEnabling) await zadiSessionsRepo.enableZadiSession(session.id);
      else await zadiSessionsRepo.disableZadiSession(session.id);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
    this.getAllSupervisors();
    this.getAllCoupons();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>

<style scoped>
.supervisor-option-chip {
  height: 22px;
  margin: 0;
}
</style>
